import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './navbar.css';

function Navbar() {
  const { t, i18n } = useTranslation("navbar"); // <-- récupérer i18n
  const [open, setOpen] = useState(false);

  const toggle = () => setOpen(o => !o);
  const close = () => setOpen(false);
  const changeLang = (lng) => {
    i18n.changeLanguage(lng); // maintenant défini
    close();
  };

  return (
    <nav className='navbar'>
      <div className="navbar-container">

        {/* Logo */}
        <Link to='/' className="navbar-logo">
          <img src="/Images/logo.png" className="logo-image" alt="logo" />
        </Link>

        {/* Liens */}
        <div className="nav-links">
          <Link to="/about">{t("about")}</Link>
          <Link to="/aircrafts">{t("buy")}</Link>
          <Link to="/contact">{t("contact")}</Link>
        </div>

        {/* Sélecteur de langue */}
        <div className="language-dropdown">
          <button
            className="lang-btn"
            onClick={toggle}
            aria-haspopup="menu"
            aria-expanded={open}
            aria-label="Change language"
            onKeyDown={(e) => e.key === 'Escape' && close()}
          >
            <span className="han">文</span>
            <span className={`arrow ${open ? 'open' : ''}`}>▾</span>
          </button>

          {open && (
            <div className="lang-menu" role="menu">
              <button className="lang-item" onClick={() => changeLang('fr')} role="menuitem">
                🇫🇷 Français
              </button>
              <button className="lang-item" onClick={() => changeLang('en')} role="menuitem">
                🇬🇧 English
              </button>
            </div>
          )}
        </div>

      </div>
    </nav>
  );
}

export default Navbar;
